import { useEffect, useRef } from 'react';

declare global {
  interface Window {
    turnstile?: {
      render(element: HTMLElement, options: { sitekey: string; theme?: 'light' | 'dark' | 'auto'; callback: (token: string) => void; 'expired-callback'?: () => void }): string;
      remove(widgetId: string): void;
    };
  }
}

export function TurnstileWidget({ siteKey, onToken }: { siteKey: string | null; onToken: (token: string | undefined) => void }) {
  const container = useRef<HTMLDivElement>(null);
  useEffect(() => {
    if (!siteKey || !container.current) return;
    const render = () => {
      if (!window.turnstile || !container.current || container.current.dataset.rendered) return;
      const id = window.turnstile.render(container.current, { sitekey: siteKey, theme: 'auto', callback: token => onToken(token), 'expired-callback': () => onToken(undefined) });
      container.current.dataset.rendered = id;
    };
    let script = document.querySelector<HTMLScriptElement>('script[data-turnstile]');
    if (!script) {
      script = document.createElement('script');
      script.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';
      script.async = true;
      script.defer = true;
      script.dataset.turnstile = 'true';
      script.onload = render;
      document.head.appendChild(script);
    } else if (window.turnstile) render(); else script.addEventListener('load', render, { once: true });
    return () => {
      const id = container.current?.dataset.rendered;
      if (id && window.turnstile) window.turnstile.remove(id);
    };
  }, [siteKey, onToken]);
  if (!siteKey) return null;
  return <div className="turnstile-slot" ref={container} />;
}
